<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-09-07 21:56:23
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-25 17:08:13
 * @Description: file content
 -->
<template>
  <div class="register">
    <div class="register-title">销售人员注册</div>
    <div class="content-info">
      <div class="info-item border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_name.png" alt />
        <span class="start">*</span>
        <input type="text" placeholder="请输入姓名" v-model="name" class="info-input" @blur="blurInput" />
      </div>
      <div class="info-item border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_sex.png" alt />
        <span class="start">*</span>
        <input type="radio" name="gender" value="1" class="info-sex" v-model="sex" />
        <label for="female">男</label>
        <input type="radio" name="gender" value="2" class="info-sex" v-model="sex" />
        <label for="male">女</label>
      </div>
      <div class="info-items border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_team.png" alt />
        <span class="start">*</span>
        <multiselect
          v-model="value"
          :options="options"
          :custom-label="nameWithLang"
          placeholder="请选择公司或搜索"
          label="firmname"
          track-by="firmname"
          :show-labels="false"
        ></multiselect>
      </div>
      <div class="info-item border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_phone.png" alt />
        <span class="start">*</span>
        <input
          type="tel"
          placeholder="请输入手机号"
          v-model="mobile"
          class="info-input"
          @blur="blurInput"
        />
      </div>
      <div class="info-item border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_vcode.png" alt />
        <span class="start">*</span>
        <input
          type="number"
          placeholder="输入验证码"
          v-model="vcode"
          oninput="if(value.length>6)value=value.slice(0,6)"
          @blur="blurInput"
          style="width:40%"
        />
        <span v-show="!showVcode" @click="getVcode" class="getvcode" style="width:40%">{{getVcodes}}</span>
        <span v-show="showVcode" class="getvcode" style="width:40%">{{counts}}s</span>
      </div>
      <div class="getMore" v-if="!ismore" @click="getmore">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_dwon.png" alt />
        <p>点击完善更多</p>
      </div>
      <div class="info-item border-bottom" v-if="ismore">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_company.png" alt />
        <span class="start"></span>
        <input
          type="text"
          placeholder="请输入公司（选填）"
          v-model="company"
          class="info-input"
          @blur="blurInput"
        />
      </div>
      <div class="info-item border-bottom" v-if="ismore">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_address.png" alt />
        <span class="start"></span>
        <input
          type="text"
          placeholder="请输入地址（选填）"
          v-model="address"
          class="info-input"
          @blur="blurInput"
        />
      </div>
      <div class="personal" v-if="ismore">
        <span>个人简介（选填）</span>
        <textarea name id cols="30" rows="10" class="personal-text" v-model="personalprofile"></textarea>
      </div>
      <div class="upwxcard" v-if="ismore">
        <span>上传个人二维码（选填）</span>
        <div class="upimg">
          <upimg :multiple="multiple" id="id" :url="url" @changeUrl="changeUrl"></upimg>
          <img :src="upimgsrc" alt v-if="upimgsrc" />
        </div>
      </div>

      <div class="submit" @click="submit">确认提交</div>
    </div>
  </div>
</template>
<script>
import upimg from "./upimg";
import utils from "@/utils/utils";
import { MessageBox } from "mint-ui";
import request from "@/utils/request";
// import * as vali from "@/utils/validate";
import Cookies from "js-cookie";
// import * as config from "./config";
import Multiselect from "vue-multiselect";
let that105 = null;
export default {
  components: {
    Multiselect,
    upimg
  },
  data() {
    return {
      ismore: false,
      name: "",
      sex: "",
      mobile: "",
      firmid: "",
      vcode: "",
      showVcode: false,
      counts: "",
      timer: null,
      getVcodes: "获取验证码",
      address: "",
      company: "",

      //   上传图片
      multiple: true,
      id: "upimg",
      // len: Number, //选择文件的个数
      url: [],
      upimgsrc: "", //上传图片
      personalprofile: "",

      value: {
        firmname:
          this.global.SUBDOMAIN == "hfgffwh" ? "请选择部门" : "请选择公司",
        id: 0
      },
      options: [
        // { name: '上海',  },
        // { name: '1',  },
        // { name: '2',  },
        // { name: '3',  },
        // { name: '4',  }
      ]
    };
  },
  watch: {
    url: {
      handler(val) {
        console.log(val[0]);
        this.upimgsrc = val[0] + "?x-oss-process=image/resize,h_200,w_200";
      }
    },
    value: {
      handler(val) {
        // console.log(val.id)
        this.firmid = val.id;
      }
    },
    vcode(v, o) {
      Cookies.remove("vericode");
      Cookies.set("vericode", v);
    }
  },
  methods: {
    nameWithLang({ firmname, id }) {
      return `${firmname}`;
    },
    //上传图片
    changeUrl(urls) {
      this.url = urls;
      //发送图片
    },
    // 获取更多
    getmore() {
      this.ismore = true;
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      that105.temporaryRepair();
    },
    //获取手机验证码/activity/logic/takeMobileVerifyCode
    getActPhoneVCode() {
      const _self = this;
      if (!_self.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        request
          .get(_self.global.API_URL, {
            action: "getVericode",
            requestParam: {
              mobile: _self.mobile
            }
          })
          .then(response => {
            if (response.code == 0) {
              MessageBox.alert(
                "验证码已通过短信发送到您的手机，稍等一会儿哦",
                "提示"
              );
            }
          });
      }
    },
    //获取验证码
    getVcode() {
      const _self = this;
      const TIME_COUNT = 60;
      _self.getActPhoneVCode();
      if (!_self.timer && _self.mobile) {
        _self.counts = TIME_COUNT;
        _self.showVcode = true;
        _self.timer = setInterval(() => {
          if (_self.counts > 0 && _self.counts <= TIME_COUNT) {
            _self.counts--;
          } else {
            _self.showVcode = false;
            _self.getVcodes = "重新获取";
            clearInterval(_self.timer);
            _self.timer = null;
          }
        }, 1000);
      }
    },
    //提交信息
    submit() {
      let _self = this;
      if (!_self.name || !_self.mobile || !_self.sex || !_self.firmid) {
        return MessageBox.alert("所有带 * 项均为必填项", "提示");
      }
      if (!_self.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        if (!utils.isMobile(_self.mobile)) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!_self.vcode) {
        return MessageBox.alert("请输入验证码", "提示");
      }
      _self.bindCompany(_self.firmid);
      Cookies.set("vericode", _self.vcode);
      request
        .get(_self.global.API_URL, {
          action: "register",
          requestParam: {
            name: _self.name,
            mobile: _self.mobile,
            sex: _self.sex,
            firmid: _self.firmid
          }
        })
        .then(response => {
          if (
            response &&
            response.code == 0 &&
            response.obj &&
            response.obj.cardno
          ) {
            _self.updateMyFans();
          } else {
            MessageBox.alert("注册失败！", "提示");
          }
        });
    },
    //绑定代理公司
    bindCompany(firmid) {
      let _self = this;
      request
        .get(_self.global.API_URL, {
          action: "dhyxcrm",
          requestParam: {
            module: "crmsalerfirm",
            oper: "seek",
            saleropenid: Cookies.get("openid"),
            firmid: firmid
          }
        })
        .then(response => {
          if (response.obj && response.obj.total > 0) {
            _self.options = response.obj.list;
          }
        });
    },

    //非必填接口/hb/HbUserAction/updateMyFans
    updateMyFans() {
      let _self = this;
      let obj = {
        openid: Cookies.get("openid"),
        name: _self.name,
        mobile: _self.mobile,
        agerange: "",
        sex: parseInt(_self.sex),
        firmid: _self.firmid,
        address: _self.address,
        city: "",
        remark: "",
        company: _self.company,
        weixin: "",
        email: "",
        ersonalprofile: _self.personalprofile,
        wxqr: _self.upimgsrc
      };
      request
        .get(_self.global.API_URL, {
          action: "/hb/HbUserAction/updateMyFans",
          requestParam: {
            obj
          }
        })
        .then(response => {
          if (response && response.code == 0) {
            if (_self.$ismp) {
              MessageBox.alert("提交成功！", "提示").then(function() {
                utils.mp.switch("/pages/rs/index/index");
              });
            } else {
              MessageBox.alert("提交成功！", "提示").then(function() {
                _self.$emit("afterRegisterVipcard");
              });
            }
          } else {
            MessageBox.alert("注册失败！", "提示").then(function() {});
          }
        });
    },
    init() {
      let _self = this;
      request
        .get(_self.global.API_URL, {
          action: "dhyxcrm",
          requestParam: {
            module: "crmsalerfirm",
            oper: "list",
            offset: 0,
            size: 500
          }
        })
        .then(response => {
          if (response.obj && response.obj.total > 0) {
            _self.options = response.obj.list;
          }
        });
    }
  },
  created() {
    that105 = this;
    this.init();
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="stylus" scoped>
.register {
  // position: absolute;
  // width: 100%;
  // min-height: 13.34rem;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  background: #fff;
}

.register .register-title {
  width: 100%;
  text-align: center;
  font-size: 0.35rem;
  color: #333;
  line-height: 1.2rem;
  height: 1.2rem;
}

.register .content-info {
  width: 90%;
  margin: 0 auto;
}

.register .content-info .info-item {
  width: 100%;
  height: 0.88rem;
  // border-bottom: 1px solid #bebebe;
  line-height: 0.88rem;
  display: flex;
}

.register .content-info .info-item>img {
  width: 0.4rem;
  height: 0.4rem;
  padding: 0.24rem 0.24rem;
}

.register .content-info .info-item .start {
  display: block;
  width: 10px;
  height: 0.88rem;
  line-height: 0.88rem;
  color: #ff775e;
}

.register .content-info .info-items {
  width: 100%;
  display: flex;
}

.register .content-info .info-items>img {
  width: 0.4rem;
  height: 0.4rem;
  padding: 0.24rem 0.24rem;
}

.register .content-info .info-items .start {
  display: block;
  width: 10px;
  height: 0.88rem;
  line-height: 0.88rem;
  color: #ff775e;
}

.register .content-info .info-item .info-input {
  flex: 1;
}

.register .content-info .info-item .info-sex {
  width: 0.3rem;
  height: 0.3rem;
  display: block;
  margin: 0.25rem 0.2rem;
  background: #ebb14e;
}

.multiselect {
  font-size: 0.28rem;
}

.register >>> .multiselect__tags {
  font-size: 0.28rem;
  border: none !important;
  padding: 8px 40px 0 0px;
}

.register >>> .multiselect__input {
  font-size: 0.28rem;
  color: #999;
}

.register >>> .multiselect__single {
  font-size: 0.28rem;
  color: #999;
}

.vcode {
  margin: 0.2rem auto;
  height: 0.88rem;
  width: 70%;
  border: 1px solid #157F89;
  border-radius: 0.1rem;
  background: #fff;
}

.vcode>input {
  width: 50%;
}

.getvcode {
  display: inline-table;
  line-height: 0.6rem;
  width: 40%;
  font-size: 0.24rem;
  margin: 0.1rem 0;
  height: 0.6rem;
  color: #fff;
  background: #fdb328;
  text-align: center;
  border-radius: 0.1rem;
}

.getMore {
  width: 100%;
  position: relative;
  height: 1.2rem;
  margin-top: 0.5rem;
}

.getMore>img {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -0.36rem;
  animation: mymove 2s infinite;
  width: 0.72rem;
  height: 0.4rem;
}

@keyframes mymove {
  from {
    top: -20px;
    transform: scale(0.6);
  }

  to {
    top: 5px;
    transform: scale(0.9);
  }
}

.getMore>p {
  width: 100%;
  height: 0.4rem;
  line-height: 1.2rem;
  text-align: center;
  font-size: 0.24rem;
  color: #999;
}

.personal {
  width: 100%;
}

.personal>span {
  width: 100%;
  height: 0.88rem;
  line-height: 0.88rem;
  color: #999;
}

.personal .personal-text {
  width: 100%;
  line-height: 0.6rem;
  height: 2.5rem;
  font-size: 0.28rem;
  background: #ebebeb;
  border-radius: 0.05rem;
}

.upwxcard {
  width: 100%;
}

.upwxcard>span {
  width: 100%;
  height: 0.88rem;
  line-height: 0.88rem;
  color: #999;
}

.upwxcard .upimg {
  width: 100%;
  height: 2rem;
  background-color: #999;
  background: url('http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_upimg.png') no-repeat; // rs.static.quanc.com.cn/yq-rs-wx/register/icon_upimg.png) no-repeat;
  background-size: 2rem 2rem;
  position: relative;
}

.upwxcard .upimg>img {
  width: 2rem;
  height: 2rem;
}

.submit {
  width: 70%;
  margin: 1rem auto;
  height: 0.88rem;
  background: #fdb328;
  color: #fff;
  font-size: 0.28rem;
  line-height: 0.88rem;
  text-align: center;
  border-radius: 0.1rem;
}
</style>


